<script>
  import Illusion from "./Illusion.svelte";
  console.log("You are on the right path");
</script>

<Illusion/>

